import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-non-vax-thank-you',
  templateUrl: './non-vax-thank-you.component.html',
  styleUrls: ['./non-vax-thank-you.component.css']
})
export class NonVaxThankYouComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {

    
  }
  startNewScreening(){
    this.router.navigateByUrl('/survey/vaxupload');
  }
}
